import { color, text_s } from '_utils/styles';
import styled from 'styled-components';
import { spacing } from "_utils/props";

export const TextArea = styled.input`
  &:focus-visible {
    outline: 2px solid #8CA0FF;
  }
  height: 48px;
  ${({ theme }) => spacing({ theme, $mt: 1, $mb: 0 })};
  padding: 10px 16px;
  border: 1px solid #DDDEE1;
  background: #F9F9F9;
  border-radius: 4px;
  &:disabled {
    background: #f0f1f2;
    border: 1px solid #dddee1;
    color: ${({ theme }) => theme.colors.all.deepBlueTint45};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  .error-validation {
    ${text_s}
    color: ${({ theme }) => theme.colors.all.pottsPointRedTint110};
    margin: 0;
    padding-left: 5px;
    margin-top: 2px;
    display: flex;
    align-items: center;
    & svg {
       ${({ theme }) => spacing({ theme, $mr: 1 })};
    }
  }
  
  .active{
    outline: 2px solid #2DB84B;
    background: #F9F9F9 !important;
  }
  
  .text-bold{
    background: #ECEFFE;
  }
  
  .error{
    color: #B00020;
    background: #FEEDF3;
  }
`;
